import React, { useEffect, useState } from "react";
import axios from "axios";
import { getCookie } from "../auth/cookies";
import { toast } from "react-toastify";

export default function TrainerAccess({ onOpenTeamModal }) {
    const [users, setUsers] = useState([]);

    // Fetch user data from API
    useEffect(() => {
        axios
            .get('/api/get_users/', { headers: { 'X-CSRFToken': getCookie('csrftoken') } })
            .then((res) => setUsers(res.data.users))
            .catch((err) => toast.error(`Error fetching users: ${err.message}`));
    }, []);

    // Toggle trainer access
    const toggleTrainerAccess = (userId, currentAccess) => {
        axios
            .post('/api/toggle_trainer_access/', 
                { user_id: userId, has_trainer_access: !currentAccess },
                { headers: { 'X-CSRFToken': getCookie('csrftoken') } }
            )
            .then(() => {
                setUsers((prevUsers) =>
                    prevUsers.map((user) =>
                        user.id === userId ? { ...user, has_trainer_access: !currentAccess } : user
                    )
                );
                toast.success(`Trainer access ${!currentAccess ? 'granted' : 'revoked'} successfully!`);
            })
            .catch((err) => toast.error(`Error toggling access: ${err.message}`));
    };

    return (
        <section className="mb-12">
            <h2 className="text-3xl text-gray-800 dark:text-gray-200 mb-4 font-semibold">Trainer Access</h2>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white dark:bg-gray-800 shadow-md rounded-lg overflow-hidden">
                    <thead className="bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200">
                        <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Username</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Email</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Trainer Access</th>
                            <th className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (
                            <tr
                                key={user.id}
                                className={`${index % 2 === 0 ? 'bg-gray-100 dark:bg-gray-700' : 'bg-white dark:bg-gray-800'} text-gray-700 dark:text-gray-300`}
                            >
                                <td className="px-6 py-4 whitespace-nowrap">{user.username}</td>
                                <td className="px-6 py-4 whitespace-nowrap">{user.email}</td>
                                <td className="px-6 py-4 whitespace-nowrap">
                                    {user.has_trainer_access ? (
                                        <span className="text-green-500">Granted</span>
                                    ) : (
                                        <span className="text-red-500">Revoked</span>
                                    )}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap flex space-x-4">
                                    <button
                                        onClick={() => toggleTrainerAccess(user.id, user.has_trainer_access)}
                                        className={`px-4 py-2 rounded-lg ${
                                            user.has_trainer_access ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'
                                        } text-white`}
                                    >
                                        {user.has_trainer_access ? 'Revoke' : 'Grant'}
                                    </button>
                                    <button
                                        onClick={() => onOpenTeamModal(user.id)} // Trigger opening of team modal
                                        className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-lg"
                                    >
                                        View Team
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
}